import _typeof from "@babel/runtime/helpers/esm/typeof";

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:26:12
 * @LastEditTime: 2020-11-25 10:55:49
 */
// ====object  对象相关的处理函数
var object = {
  /**
     * 序列化JSON对象
     * 对object转化为url参数字符串，各属性间以&分隔，如a=1&b=2&c=3
     * 对象属性为string 则进行encodeURIComponent编码
     * 对象属性为bool 则以0代表false 1代表true
     * 对象属性为对象，则会继续进行递归序列化
     * 对象属性为function 则返回function.toString
     * @param {object} jsonObj json对象
     * @return {string}
     */
  serialize: function serialize(jsonObj) {
    var newJsonObj = null;
    if (typeof jsonObj === 'undefined' || typeof jsonObj === 'function') newJsonObj = '';
    if (typeof jsonObj === 'number') newJsonObj = jsonObj.toString();
    if (typeof jsonObj === 'boolean') newJsonObj = jsonObj ? '1' : '0';

    if (_typeof(jsonObj) === 'object') {
      if (!jsonObj) newJsonObj = '';
      if (jsonObj instanceof RegExp) newJsonObj = jsonObj.toString();
    }

    if (typeof jsonObj === 'string') newJsonObj = jsonObj;
    if (typeof newJsonObj === 'string') return encodeURIComponent(newJsonObj);
    var ret = [];

    if (jsonObj instanceof Array) {
      for (var i = 0; i < jsonObj.length; i++) {
        if (typeof jsonObj[i] === 'undefined') continue;
        ret.push(_typeof(jsonObj[i]) === 'object' ? '' : this.serialize(jsonObj[i]));
      }

      return ret.join('|');
    }

    for (var _i in jsonObj) {
      if (typeof jsonObj[_i] === 'undefined') continue;
      newJsonObj = null;

      if (_typeof(jsonObj[_i]) === 'object') {
        if (jsonObj[_i] instanceof Array) {
          newJsonObj = jsonObj[_i];
          ret.push("".concat(_i, "=").concat(this.serialize(newJsonObj)));
        } else {
          ret.push("".concat(_i, "="));
        }
      } else {
        newJsonObj = jsonObj[_i];
        ret.push("".concat(_i, "=").concat(this.serialize(newJsonObj)));
      }
    }

    return ret.join('&');
  },

  /**
     * 反序列化为JSON对象
     * 对url参形形式的对象反序列化成为JSON对象
     * 与serialize相对应
     * @param {object} jsonObj json对象
     * @return {string}
     */
  unSerialize: function unSerialize(jsonStr, de) {
    de = de || 0;
    jsonStr = jsonStr.toString();
    if (!jsonStr) return {};
    var retObj = {};
    var obj1Ret = jsonStr.split('&');
    if (obj1Ret.length == 0) return retObj;

    for (var i = 0; i < obj1Ret.length; i++) {
      if (!obj1Ret[i]) continue;
      var ret2 = obj1Ret[i].split('=');

      if (ret2.length >= 2) {
        var ret0 = obj1Ret[i].substr(0, obj1Ret[i].indexOf('='));
        var ret1 = obj1Ret[i].substr(obj1Ret[i].indexOf('=') + 1);
        if (!ret1) ret1 = '';
        if (ret0) retObj[ret0] = de == 0 ? decodeURIComponent(ret1) : ret1;
      }
    }

    return retObj;
  },

  /**
     * 对整个object进行utf8格式的url解码
     * @param {object} newopt 解码对象
     * @return {object} 已解码对象
     */
  decode: function decode(newopt) {
    if (typeof newopt === 'string') {
      try {
        return decodeURIComponent(newopt);
      } catch (e) {
        console.log(e);
      }

      return newopt;
    }

    if (_typeof(newopt) === 'object') {
      if (newopt == null) {
        return null;
      }

      if (newopt instanceof Array) {
        for (var i = 0; i < newopt.length; i++) {
          newopt[i] = object.decode(newopt[i]);
        }

        return newopt;
      }

      if (newopt instanceof RegExp) {
        return newopt;
      }

      for (var _i2 in newopt) {
        newopt[_i2] = object.decode(newopt[_i2]);
      }

      return newopt;
    }

    return newopt;
  }
};
export default object;